var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("h2", [_vm._v("BedBoard Application")]),
    _c("p", [_vm._v("Version " + _vm._s(_vm.appVersion))]),
    _c("p", [_vm._v("Scope " + _vm._s(_vm.scopeID))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }